import SpanishPlanFinder from '../find-a-plan';
import {graphql} from 'gatsby';

export const query = graphql`
  query SpanishPlanFinderLocations {
    ...PageLayout

    allPbps {
      nodes {
        csnp_conditions {
          type
        }
        name
        plan {
          ma_variant
          plan_type
        }
        record_locator
        service_areas {
          county_code
        }
        year
      }
    }
    site {
      siteMetadata {
        ssaCountiesForPbps {
          code
          display_name
          state_abbreviation
          zip_codes {
            zip_code
          }
        }
        supportedCounties {
          county_code
          pages {
            lang
            path
          }
        }
      }
    }
  }
`;

export default SpanishPlanFinder;
